// Photo-set fingerprint — MUST stay in lockstep with `photosKey()` in
// worker/src/routes/ai.ts. Identifies EXACTLY which photo set an AI layout
// generation was computed for, independent of order/transport/timing.
//
// Used by the AI Magic resilience flow (Fix D): when the client recovers a
// pending generation after a phone-backgrounding, it compares this key against
// the worker-stored pending_ai_layout.photos_key. A mismatch (the customer
// added/removed a photo since the run started) means the pending result is
// STALE and must be ignored — never apply a layout built for a different set.
//
// FNV-1a over the SORTED, comma-joined ids → `<hex>:<count>`.
export function photosKey(ids: string[]): string {
  const joined = [...ids].sort().join(',');
  let h = 0x811c9dc5;
  for (let i = 0; i < joined.length; i++) {
    h ^= joined.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0') + ':' + ids.length;
}
